export enum PaymentMethodEnum {
    BankTransfer = 'BANK_TRANSFER',
    Bkash = 'BKASH',
    Nagad = 'NAGAD',
    Rocket = 'ROCKET',
    Cash = 'CASH'
}